export enum AssigmentPermissions {
  Assigment = 'assignment',
}
